import { collectFieldType } from '_shared/constants/collectionTypes';

export function applyReviewFieldToFormData(prev, field, value) {
  const next = { ...prev };
  if (field !== collectFieldType.RALLY_LENGTH && prev[field] === value) {
    next[field] = null;
  } else {
    next[field] = value;
  }
  return next;
}
